import { captureException } from "@sentry/react"

/** Properly escapes a CSV cell value */
const escapeCsvCell = (cell: string | null | undefined): string => {
  const cellStr = String(cell ?? "")

  // Check if cell needs quoting (contains comma, quote, newline, carriage return, or tab)
  if (
    cellStr.includes(",") ||
    cellStr.includes('"') ||
    cellStr.includes("\n") ||
    cellStr.includes("\r") ||
    cellStr.includes("\t")
  ) {
    // Escape quotes by doubling them and wrap in quotes
    return `"${cellStr.replace(/"/g, '""')}"`
  }

  return cellStr
}

/** Converts 2D array to CSV format and copies to clipboard */
export const copyToClipboardAsCSV = (data: string[][]): void => {
  // If only one cell (excluding header), copy as plain text
  if (data.length === 2 && data[0].length === 1 && data[1].length === 1) {
    navigator.clipboard.writeText(data[1][0]).catch((err) => {
      captureException(err, { tags: { source: "clipboard-copy-single" } })
    })
    return
  }

  const csvData = data.map((row) => row.map(escapeCsvCell).join(",")).join("\n")

  navigator.clipboard.writeText(csvData).catch((err) => {
    captureException(err, { tags: { source: "clipboard-copy" } })
  })
}
